import { createFileRoute, Outlet } from "@tanstack/react-router";
import { SuperadminHeader } from "../components/superadmin/SuperadminHeader";

export const Route = createFileRoute("/superadmin/audit-log")({
  component: SuperadminAuditLogLayout,
});

function SuperadminAuditLogLayout() {
  return (
    <div className="flex h-screen flex-col bg-background">
      <SuperadminHeader
        title="Audit Log"
        subtitle="Content changes across all orgs"
      />

      {/* Content */}
      <main className="flex-1 overflow-auto p-6">
        <div className="container mx-auto max-w-6xl">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
